import React, {useState, useEffect} from "react";
import {Popup} from "./FeedPopup";
import {formatDesc} from "../scripts/feed.js";
import "../styling/Feed.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import app, {db} from "../utils/firebase";
import Papa from "papaparse"
import {Helmet} from 'react-helmet';
import { onValue, ref, set, get, query, equalTo, orderByChild, once, orderByValue, off, update } from "firebase/database";

export default function Feed() {
    const [feedName, setFeedName] = useState("");
    const [feedColor, setColor] = useState("#FFFFFF");
    const [feedTheme, setTheme] = useState("light");
    const [feedCols, setCols] = useState([]);
    const [feedItems, setFeedItems] = useState([]);
    const [originalFeedItems, setOriginalFeedItems] = useState([]); 
    const [feedURL, setFeedURL] = useState("");

    const [feedFilters, setFilters] = useState([]);
    const [allFilters, setAllFilters] = useState({});
    const [currentFilters, setCurrentFilters] = useState({});

    const [headlineCol, setHeadlineCol] = useState("");
    const [descCol, setDescCol] = useState("");
    const [footerCol, setFooterCol] = useState("");

    const [passwordEntered, setPasswordEntered] = useState(false);
    const [passwordText, setPasswordText] = useState("");
    const [passwordGuess, setPasswordGuess] = useState("");

    const [popup, openPopup] = useState(false);
    const [loading, setLoading] = useState(true);

    const isValidURL = (string) => {
        try {
          new URL(string);
          return true;
        } catch (_) {
          return false;
        }
    };

    useEffect(() => {

        const fetchData = async () => {
            try {
                const url = window.location.href;
                const alias = url.split("/").pop();
                const feedRef = ref(db, "feeds/" + alias + "/");
    
                const snapshot = await get(feedRef);
                const feed = snapshot.val();
                if (feed != null) {
                    setFeedName(feed.title);
                    setCols(feed.cols);
                    setHeadlineCol(feed.head);
                    setDescCol(feed.desc);
                    setFooterCol(feed.footer);
                    setColor(feed.color);
                    setTheme(feed.theme);
                    setFeedURL(feed.url);    
                    if (feed.password.enabled) {
                        setPasswordText(feed.password.text);
                    } 
    
                    Papa.parse(feed.url, {
                        download: true,
                        header: true,
                        complete: function (results) {
                          if (results && Array.isArray(results.data)) {
                            const filteredData = results.data.filter(item => Object.values(item).some(value => value !== null && value !== ""));
                            setFeedItems(filteredData);
                            setOriginalFeedItems(filteredData);
                      
                            let filters = [];
                            for (var i = 0; i < feed.filters.length; i++) {
                              if (feed.filters[i] == true) {
                                filters.push(feed.cols[i]);
                              }
                            }
                            setFilters(filters);
                            setCurrentFilters(
                                Object.fromEntries(filters.map((filter) => [filter, []]))
                            );
                      
                            let allFiltersData = {};
                            filters.forEach((filter) => {
                              let newFilter = [];
                              for (var j = 0; j < results.data.length; j++) {
                                if (results.data[j][filter] != null && !newFilter.includes(results.data[j][filter])) {
                                  newFilter.push(results.data[j][filter]);
                                }
                              }
                              allFiltersData[filter] = newFilter;
                            });


                            setAllFilters(allFiltersData);
                      
                            setLoading(false);
                          } else {
                            console.error("Parsed data is invalid:", results);
                          }
                        },
                        error: function (error) {
                          console.error("Error parsing data:", error);
                        },
                      });
                      
                } else {
                    return window.location.href = window.location.origin + "?error=fnf";
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    }, []);
    

    const openFeedItem = (item) => {
        openPopup({
            head: item[headlineCol],
            desc: item[descCol],
            footer: item[footerCol]
        });
      };

    const appyFilters = () => {
        let newFeedItems = [];
        for (var i = 0; i < originalFeedItems.length; i++) {
            let item = originalFeedItems[i];
            let add = true;
            for (var j = 0; j < feedFilters.length; j++) {
                let filter = feedFilters[j];
                if (currentFilters[filter].length > 0) {
                    if (!currentFilters[filter].includes(item[filter])) {
                        add = false;
                    }
                }
            }
            if (add) {
                newFeedItems.push(item);
            }
        }
        setFeedItems(newFeedItems);
    }

      return (
        <>  
            {feedTheme === "light" && !loading && (
                <Helmet>
                    <style>{`
                        body { background-color: #f7f9fc; color: #0f172a; }
                        .feed-header { background: rgba(247,249,252,0.95); border-bottom: 3px solid ${feedColor}; }
                        .feed-item { border-bottom-color: rgba(0,0,0,0.07); }
                        .feed-item:hover { background: rgba(0,0,0,0.025); }
                        .feed-item-desc { color: #475569; }
                        .feed-footer-meta { color: #94a3b8; }
                        .feed-filter { border-color: rgba(0,0,0,0.15); color: #374151; background: transparent; }
                        .current-filters { border-bottom-color: rgba(0,0,0,0.07); }
                        .link { color: #3b82f6; }
                    `}</style>
                </Helmet>
            )}
            {feedTheme === "dark" && !loading && (
                <Helmet>
                    <style>{`
                        body { background-color: #0f172a; color: #f1f5f9; }
                        .feed-header { background: rgba(15,23,42,0.97); border-bottom: 3px solid ${feedColor}; }
                        .feed-item { border-bottom-color: rgba(255,255,255,0.07); }
                        .feed-item:hover { background: rgba(255,255,255,0.04); }
                        .feed-item-desc { color: #94a3b8; }
                        .feed-footer-meta { color: #64748b; }
                        .feed-filter { border-color: rgba(255,255,255,0.15); color: #e2e8f0; background: transparent; }
                        .current-filters { border-bottom-color: rgba(255,255,255,0.07); }
                        .popup .popup-item { background: #1e293b; color: #f1f5f9; border: 1px solid rgba(255,255,255,0.1); }
                        .popup .feed-item-header { color: #f1f5f9; }
                        .popup .feed-item-desc { color: #94a3b8; }
                        .link { color: #60a5fa; }
                    `}</style>
                </Helmet>
            )}

            {/* Prominent feed header — no Layout nav on this page */}
            {feedName !== "" && !loading && (passwordEntered || passwordText == "") && (
                <header className="feed-header">
                    <div className="feed-header-inner">
                        <h1 className="feed-title">{feedName}</h1>
                        <a className="feed-attribution" href={window.location.origin} target="_blank" rel="noreferrer">
                            Made with Sheet2Feed ↗
                        </a>
                    </div>
                </header>
            )}

            <div className="feed-timeline">
                {/* Filter dropdowns */}
                {feedFilters !== null && feedFilters.length !== 0 && !loading && Object.keys(allFilters).length !== 0 && (passwordEntered || passwordText == "") && (
                    <div className="feed-filters">
                        <div className="scroll">
                            {feedFilters.map((filter, index) => (
                                <select className="feed-filter" defaultValue="" key={index} onChange={(e) => {
                                    let newFeedItems = feedItems.filter(item => item[filter] === e.target.value);
                                    setFeedItems(newFeedItems);
                                    let newCurrentFilters = {...currentFilters};
                                    if (!newCurrentFilters[filter].includes(e.target.value)) {
                                        newCurrentFilters[filter].push(e.target.value);
                                        setCurrentFilters(newCurrentFilters);
                                    }
                                }}>
                                    <option hidden value="">Filter by {filter}</option>
                                    {allFilters[filter].map((item, ind) => (
                                        <option key={ind} value={item}>{item}</option>
                                    ))}
                                </select>
                            ))}
                        </div>
                    </div>
                )}

                {/* Active filter chips */}
                <div className="current-filters">
                    {feedFilters !== null && feedFilters.length !== 0 && !loading && (passwordEntered || passwordText == "") &&
                        feedFilters.map((filter, index) =>
                            currentFilters[filter] && currentFilters[filter].map((item, ind) => (
                                <span className="current-filter" key={ind} onClick={() => {
                                    let newCurrentFilters = {...currentFilters};
                                    newCurrentFilters[filter].splice(ind, 1);
                                    setCurrentFilters(newCurrentFilters);
                                    appyFilters();
                                }}>
                                    {item} ✕
                                </span>
                            ))
                        )
                    }
                </div>

                {/* Posts */}
                <div className="feed">
                    {feedItems !== null && feedItems.length !== 0 && headlineCol !== null && !loading && (passwordEntered || passwordText == "") && (
                        feedItems.map((item, index) => (
                            <article className="feed-item" key={index} onClick={() => openFeedItem(item)}>
                                <h2 className="feed-item-header">{item[headlineCol]}</h2>
                                <p className="feed-item-desc">
                                    {isValidURL(item[descCol])
                                        ? <a className="link" href={item[descCol]} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>{item[descCol]}</a>
                                        : formatDesc(item[descCol])
                                    }
                                </p>
                                {item[footerCol] && (
                                    <div className="feed-footer">
                                        <span className="feed-footer-meta">{item[footerCol]}</span>
                                    </div>
                                )}
                            </article>
                        ))
                    )}
                    {loading && <div className="loader"></div>}
                    {passwordText !== "" && !passwordEntered && (
                        <div className="password">
                            <h1 className="password-title">This feed is password protected.</h1>
                            <p className="password-text">Enter the password to access this feed.</p>
                            <input className="password-input" type="password" placeholder="Password" onChange={(e) => setPasswordGuess(e.target.value)} />
                            <button className="password-button" onClick={() => {
                                if (passwordGuess === passwordText) setPasswordEntered(true);
                                else alert("Incorrect password");
                            }}>Unlock</button>
                        </div>
                    )}
                </div>
            </div>
            {popup ? <Popup openPopup={openPopup} item={popup} /> : null}
        </>
    )
}